app.service('scrollTop',function(front,html){
	var pageTopScrollerEnabled = true;
	var pageTopScrollerThreshold = 200;

	function init() {
		var threshold = $(document).height() / $(window).height() >= 3;
		var isNotBottomButtonPresent = $('#product-buttons-fixed').length === 0;

		if(front.page() !== "product"){
			pageTopScrollerEnabled = threshold;
		}
		else {
			pageTopScrollerEnabled = threshold && isNotBottomButtonPresent;
		}

		setElements();
		setEvents();
	}

	function setElements(){
		$('#container').append('<div id="scroll-top-container"><a href="#" id="scroll-top"></a></div>');
	}
	function setEvents(){
		$(document).on('click', 'a#scroll-top', function(e){
			e.preventDefault();
			$('body,html').animate({scrollTop: 0}, 500);
		});
		if(pageTopScrollerEnabled){
			html.add('scrollTop-enabled');
			$(window).on('scroll', function(){
				scroll();
			});
		}
		$(window).on('orientationchange',function(){
			init();
		});
	}
	function scroll(){
		if( $(window).scrollTop() > pageTopScrollerThreshold){
			html.add('scrollTop-visible');
		}
		else {
			html.remove('scrollTop-visible');
		}
	}
	return {
		init:init
	};
});